import {
  AfterViewInit,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Barcode, BarcodeScanner } from "@capacitor-mlkit/barcode-scanning";
import { AlertController, ModalController, Platform } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { BranchDeepLinks } from "capacitor-branch-deep-links";
import { OrderNowModalPopupsService } from "src/app/services/orderNowModalPopupsService/orderNowModalPopups.service";
import * as BranchLinkDataActions from "../../../store/branch-link-data/branchLinkData.actions";
import * as fromApp from "../../../store/app.reducer";
import { Store } from "@ngrx/store";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { DataStorageService } from "../../../services/data-storage/data-storage.service";
import { Capacitor } from "@capacitor/core";



import * as _ from "lodash";
import { DineinTableLabelService } from "../../../services/dinein-table-label/dinein-table-label.service";
import { Subscription } from "rxjs";
import { DineinTableLabelContext } from "../../../services/dinein-table-label/dinein-table-label.helpers";

@Component({
  selector: "app-qr-scan-modal",
  templateUrl: "./qr-scan-modal.component.html",
  styleUrls: ["./qr-scan-modal.component.scss"],
})
export class QrScanModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("square") public squareElement:
    | ElementRef<HTMLDivElement>
    | undefined;
  unsubscribeBackEvent: any;

  public url = `http://localhost:3000`;

  public dineinTableContext: DineinTableLabelContext = null;
  private dineinTableContextSub: Subscription;

  constructor(
    private readonly ngZone: NgZone,
    private platform: Platform,
    private readonly modalController: ModalController,
    private alertController: AlertController,
    private translateService: TranslateService,
    private orderNowModalPopupsService: OrderNowModalPopupsService,
    private store: Store<fromApp.AppState>,
    private http: HttpClient,
    private dataStorageService: DataStorageService,
    private dineinTableLabelService: DineinTableLabelService
  ) {
//  this.handlePermissions()
  }

  ngOnInit() {
    this.dineinTableContextSub =
      this.dineinTableLabelService.context$.subscribe((context) => {
        this.dineinTableContext = context;
      });
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      300,
      () => {
        if (this.platform.is("android")) {
          this.closeModal();
        }
      }
    );
  }

//   private async handlePermissions() {
//   const check = await BarcodeScanner.checkPermissions();
//   console.log("Permission check result:", check);

//   if (check.camera !== "granted") {
//     console.log("Requesting camera permissions...");
//     const request = await BarcodeScanner.requestPermissions();
//     console.log("Permission request result:", request);
//   }
// }
async openAppSettings() {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  try {
    await BarcodeScanner.openSettings();
  } catch (error) {
    console.log("Failed to open settings", error);
  }
}
  public bitlyUrlToNormal(bitlyUrl) {
    //todo change the strings in resolve with an object maybe containing the errors
    console.log("are we in?");
    return new Promise((resolve) => {
      this.dataStorageService
        .changeBitlyToRealUrlForRedirect(bitlyUrl)
        .subscribe({
          next: (url) => {
            if (url && !_.isEmpty(url)) {
              console.log("the response from api", url);
              resolve(url);
            } else {
              resolve("url is not in correct form");
            }
          },
          error: (error) => {
            resolve("failed to get url from bitly");
            console.log("error on link from bitly", error);
          },
        });
    });
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.startScan();
    }, 250);
  }

  public ngOnDestroy(): void {
    if (this.dineinTableContextSub) {
      this.dineinTableContextSub.unsubscribe();
    }
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
    this.stopScan();
  }

  private async startScan(): Promise<void> {
    // Hide everything behind the modal (see `src/theme/variables.scss`)
    document.querySelector("body")?.classList.add("barcode-scanning-active");

    const squareElementBoundingClientRect =
      this.squareElement?.nativeElement.getBoundingClientRect();
    const scaledRect = squareElementBoundingClientRect
      ? {
          left: squareElementBoundingClientRect.left * window.devicePixelRatio,
          right:
            squareElementBoundingClientRect.right * window.devicePixelRatio,
          top: squareElementBoundingClientRect.top * window.devicePixelRatio,
          bottom:
            squareElementBoundingClientRect.bottom * window.devicePixelRatio,
          width:
            squareElementBoundingClientRect.width * window.devicePixelRatio,
          height:
            squareElementBoundingClientRect.height * window.devicePixelRatio,
        }
      : undefined;
    const detectionCornerPoints = scaledRect
      ? [
          [scaledRect.left, scaledRect.top],
          [scaledRect.left + scaledRect.width, scaledRect.top],
          [
            scaledRect.left + scaledRect.width,
            scaledRect.top + scaledRect.height,
          ],
          [scaledRect.left, scaledRect.top + scaledRect.height],
        ]
      : undefined;
    const listener = await BarcodeScanner.addListener(
      "barcodesScanned",
      async (event) => {
        this.ngZone.run(async () => {
          const cornerPoints = event.barcodes;
          // if (detectionCornerPoints && cornerPoints) {
          //   if (
          //     detectionCornerPoints[0][0] > cornerPoints[0][0] ||
          //     detectionCornerPoints[0][1] > cornerPoints[0][1] ||
          //     detectionCornerPoints[1][0] < cornerPoints[1][0] ||
          //     detectionCornerPoints[1][1] > cornerPoints[1][1] ||
          //     detectionCornerPoints[2][0] < cornerPoints[2][0] ||
          //     detectionCornerPoints[2][1] < cornerPoints[2][1] ||
          //     detectionCornerPoints[3][0] > cornerPoints[3][0] ||
          //     detectionCornerPoints[3][1] < cornerPoints[3][1]
          //   ) {
          //     return;
          //   }
          // }
          listener.remove();
          //this.closeModal();
          const qrCode: Barcode | undefined = event.barcodes[0];
          console.log("qrCode", qrCode);
          let url: any;
          if (qrCode) {
            url = await this.bitlyUrlToNormal(qrCode.rawValue);
            console.log("the url is", url);

            setTimeout(async () => {
              await BranchDeepLinks.handleUrl({
                branch: url.finalUrl,
              });
              this.store.dispatch(
                new BranchLinkDataActions.SetTriggerForNewBranchLinkData(
                  Date.now().toString()
                )
              );
            }, 500);

            // window.open(qrCode.rawValue, "_system");
            this.closeModal();

            // await App.exitApp();
            //const qrData=this.getData().subscribe((response) => {this.qrData = });

            // if (data && data.table_id && data.store_id) {
            //   //Open dine in modal with table_id and store_id filled
            //   this.orderNowModalPopupsService.closeDineInModal();
            //   this.orderNowModalPopupsService.openDineInModal(
            //     data.table_id,
            //     data.store_id
            //   );
            // }
            //window.open(qrCode.rawValue);
            //
            // window.location.href = qrCode.rawValue;
            //
          }
          console.log("the qrcode before parse", qrCode);
        });
      }
    );

    await BarcodeScanner.startScan().catch( async (reason) => {
      console.log("reason", reason);
      const alert = await this.alertController.create({
        header: this.translateService.instant("error"),
        message: this.translateService.instant(
          "camera_permission_needed_to_scan_qr"
        ),
        backdropDismiss: true,
        buttons: [
          {
            text: this.translateService.instant("open_settings"),
            handler: async () => {
              await this.openAppSettings();
            },
          },
          {
            text: "OK",
            role: "cancel",
          },
        ],
      });
      await alert.present();
      this.closeModal();    
      await alert.onDidDismiss();
      if (!Capacitor.isNativePlatform()) {
        this.showToastForScanQr();
      }
    });
  }

  async showToastForScanQr() {
    const alert = await this.alertController.create({
      header: this.translateService.instant("alert"),
      message: this.dineinTableLabelService.instant("open_camera_and_scan_table_qr"),
      backdropDismiss: true,
      buttons: ["OK"],
    });
    await alert.present();
    await alert.onDidDismiss().then(() => {
      this.orderNowModalPopupsService.closeSettingsModal();
      this.modalController.dismiss();
    });
  }

  private async stopScan(): Promise<void> {
    // Show everything behind the modal again
    document.querySelector("body")?.classList.remove("barcode-scanning-active");

    await BarcodeScanner.stopScan();
  }

  public async closeModal(): Promise<void> {
    this.modalController.dismiss();
  }
}
